import React, { useState } from "react";
import classNames from "classnames";
import "./Filter.css";
import { Link } from "react-router-dom";
export default function Filter(props) {
  const { filterList, defaultSelected, handleFilterClick } = props;
  const [activeNav, setActiveNav] = useState(defaultSelected);
  const handleActiveNav = (row) => {
    if (
      row.filterValue === "RENEWALPOLICY" ||
      row.filterValue === "NEWPOLICY" ||
      row.filterValue === "PREMIUM" ||
      row.filterValue === "NONPREMIUM"

    ) {
    } else {
      setActiveNav(row.label);
      handleFilterClick(row);
    }
  };
  const renderOptions = (row, index) => {
    return (
      <li
        key={index}
        onClick={() => handleActiveNav(row)}
        className={classNames({
          "nav-item": true,
          leftNav: index === 0,
          middleNav: index !== 0 || filterList.length - 1 !== index,
          rightNav: filterList.length - 1 === index,
          activeNav: activeNav === row.label,
        })}
      >
        <Link className="nav-link">
          {row.label}: {row.count}
        </Link>
      </li>
    );
  };

  return (
    <ul className={"nav nav-pills float-right navContainer"}>
      {filterList.map((row, index) => {
        return renderOptions(row, index);
      })}
    </ul>
  );
}
